import { UPDATE_VIEWPORT } from './constants'
import { minWidthMd, minWidthLg } from '../../shared/breakpoints'

export function updateViewport (newWidth) {
  return (dispatch) => {
    const isMobile = newWidth < minWidthMd
    const isTablet = newWidth >= minWidthMd && newWidth < minWidthLg
    const newViewport = {
      width: newWidth,
      isMobile,
      isTablet,
    }
    return dispatch({
      type: UPDATE_VIEWPORT,
      payload: newViewport,
      meta: {
        throttle: 1000,
      },
    })
  }
}
